import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomHttp } from '../../../common/customHttp.service';
import { CharsGroupingService } from '../../../common/charsgrouping.service';
import { ApiUrl } from '../../../common/apiUrls';
import { MainAppComponent } from '../../../layout/layout.component';
import { ToastrService } from 'ngx-toastr';
import { CustomerModel } from '../../../common/viewModels/Admin/CustomerModel';

@Component({
    selector: 'customerchars',
    templateUrl: './customerchars.component.html',
    // styleUrls: ['./spidchars.component.scss']
})
export class CustomerCharsComponent implements OnInit {

    lstCustomerChars: any[];
    lstCustomerCharsTemp: any[];
    customerId: number;
    customerChars: CustomerModel = new CustomerModel();
    isCompressed: boolean = false;

    constructor(public _router: Router,
        private _http: CustomHttp,
        private _appUrl: ApiUrl, private _route: ActivatedRoute, private _mApp: MainAppComponent,
        private _toastrService: ToastrService, private _charsGrpSrvc: CharsGroupingService) {
        this._mApp.ShowLoader();
    }

    ngOnInit() {
        this.customerId = this._route.snapshot.params['id'];
        this.GetListOfCustomerChars(this.customerId);

    }

    GetListOfCustomerChars(customerId) {
        this._mApp.ShowLoader();
        this._http.get(this._appUrl.GetListOfCustomerChars + customerId)
            .subscribe(
                data => {
                    if (data.json().Result != null) {
                        this.lstCustomerChars = data.json().Result;
                        this.lstCustomerCharsTemp = data.json().Result;
                    }
                    this._mApp.HideLoader();
                },
                error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result, '');
                }
            )
    }

    OnSubmit() {
        this._mApp.ShowLoader();
        let values = [];
        for (let item of this.lstCustomerCharsTemp) {
            if (item.SubCharcteristics != null && item.SubCharcteristics != "" && item.SubCharcteristics != undefined) {
                for (let item2 of item.SubCharcteristics) {
                    if (item2.IsChecked)
                        values.push(item2.CharacteristicId)
                }
            }
            else if (item.IsChecked) {
                values.push(item.CharacteristicId)
            }
        }
        this.customerChars.CustomerId = this.customerId;
        this.customerChars.lstCharIds = values;
        this._http.post(this._appUrl.UpsertCustomerChars, this.customerChars)
            .subscribe(
                data => {
                    this._mApp.HideLoader();
                    this._toastrService.success(data.json().Result, '');
                    this._router.navigate(['/CustomerList']);
                },
                error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result, '');
                }
            )
    }

    collapseDivison(index, isCollapsed) {
        this.lstCustomerChars[index].Collapsed = !isCollapsed;
    }

    checkOruncheckAll(index, event) {
        this.lstCustomerChars = this._charsGrpSrvc.checkOruncheckAll(index, event, this.lstCustomerChars);
        this.lstCustomerCharsTemp = this._charsGrpSrvc.checkOruncheckAllTemp(index, event, this.lstCustomerCharsTemp, this.lstCustomerChars);
    }

    checkOrUncheckMain(mainIndex) {
        this.lstCustomerChars = this._charsGrpSrvc.checkOrUncheckMain(mainIndex, this.lstCustomerChars);
        this.lstCustomerCharsTemp = this._charsGrpSrvc.checkOrUncheckMainTemp(mainIndex, this.lstCustomerCharsTemp, this.lstCustomerChars);

    }

    compressOrExpand() {
        if (this.lstCustomerChars != null && this.lstCustomerChars != undefined)
            for (let i = 0; i < this.lstCustomerChars.length; i++) {
                this.lstCustomerChars[i].Collapsed = !this.isCompressed;
            }
        this.isCompressed = !this.isCompressed;
    }

    specialSearch(val) {
        this.lstCustomerChars = this._charsGrpSrvc.specialSearch(val, this.lstCustomerCharsTemp);
    }

}